import { constant } from "common/constant";
import React from "react";
import moment from "moment";

const formatDate = (isoString) => {
  if (!isoString) return "-";

  const date = new Date(isoString);
  if (isNaN(date.getTime())) return constant?.invalidDate;

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "long" }).substring(0, 3);
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = date.getHours() >= 12 ? "pm" : "am";

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

const DateFormatter = (dateString) => {
  return formatDate(dateString);
};
export const formatDateTime = (date) => {
  if (!date) {
    return "-"; // Return "-" if date is empty or falsy
  }
  return moment(date).format("DD-MM-YYYY");
};
export const formatTimestamp = (timestamp) => {
  if (timestamp && typeof timestamp === "string" && timestamp.includes(" ")) {
    const dateParts = timestamp.split(" ");
    const [day, month, year] = dateParts[0].split("-");
    const timeParts = dateParts[1].split(":");
    const hour = timeParts[0];
    const minutes = timeParts[1];

    const monthMap = {
      Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
      Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
    };

    const formattedMonth = monthMap[month];
    if (formattedMonth) {
      return `${year}-${formattedMonth}-${day}T${hour}:${minutes}`;
    }
  }

  return null;
};

export const formatDateString = (dateString) => {
  // Check if the input is in "DD-MMM-YYYY HH:MM pm/AM" format
  const regex = /^(\d{2})-(\w{3})-(\d{4}) (\d{2}):(\d{2}) (am|pm)$/;

  const match = dateString.match(regex);
  if (!match) {
    console.error("Invalid date format:", dateString);
    return "";
  }

  const [_, day, month, year, hours, minutes, period] = match;

  const monthMap = {
    Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
    Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
  };
  const monthNumber = monthMap[month];

  let hours24 = parseInt(hours);
  if (period === "pm" && hours24 < 12) {
    hours24 += 12;
  } else if (period === "am" && hours24 === 12) {
    hours24 = 0;
  }

  const date = new Date(year, monthNumber, day, hours24, minutes);

  if (isNaN(date.getTime())) {
    console.error("Invalid date:", dateString);
    return "";
  }

  // Format the date to YYYY-MM-DDTHH:MM for datetime-local
  const formattedDate = date.toISOString().slice(0, 16);  // YYYY-MM-DDTHH:MM

  return formattedDate;
};

export default DateFormatter;
